export const CONTAINER_WIDTH = 538;
export const PADDING_WIDTH = 24;
export const BORDER_WIDTH = 1;
export const OPTIONS_GAP = 8;
export const VISIBLE_OPTIONS_NUMBER = 4;
export const OPTION_WIDTH =
  (CONTAINER_WIDTH -
    2 * PADDING_WIDTH -
    2 * BORDER_WIDTH -
    (VISIBLE_OPTIONS_NUMBER - 1) * OPTIONS_GAP) /
  VISIBLE_OPTIONS_NUMBER;
